import { Input } from "@/components/ui/input";
import { useFieldContext } from "@/features/question/components/organisms/FieldRenderer";
import { useEffect, useRef, useState } from "react";
import { ZodError, z } from "zod";



export function CurrencyRenderer() {
    const { question, setFormValue, disabled, response, setSubmitDisabled, currentValue } = useFieldContext();
    const { field_min: min, field_max: max, field_decimal_places: decimal, field_integer_places: integer } = question;
    const [value, setValue] = useState<string | undefined>(undefined);
    const errorRef = useRef<ZodError>();
    let schema = z.number()

    if (decimal) {
        // schema.refine(v=> v * 10 ** decimal - Math.trunc(v ** decimal) < Number.EPSILON )
        schema = schema.multipleOf(10 ** -decimal, { message: `Only ${decimal} decimal places are allowed` })
    }
    if (integer !== undefined && integer !== null) {
        const splitValue = (separator: string) => (v: number) => {
            const res = v.toString().split(separator).map(v=> v !== '' && v !== null && v !== undefined && v !== 'NaN' && v !== '0' ? v : '');
            console.log(res)
            return res;
        };
        const periodSplittedValue = splitValue(".");
        schema = schema.refine(v => periodSplittedValue(v)[0].length <= integer, { message: `Only ${integer} integer places are allowed` })
    }

    useEffect(() => {
        if(currentValue) {
            setValue(currentValue);
        }
    }, [currentValue]);

    useEffect(() => {
        const prepValue = value !== undefined ? Number(value)?.toString() ?? '' : undefined;
        setFormValue && setFormValue(prepValue);
    }, [setFormValue, value]);

    return (
        <div className="flex flex-col gap-2">

            {!disabled ? (
                <div className="flex">
                    <div className="flex items-center px-2 bg-gray-100 border rounded me-1">$</div>

                    <Input
                        type="number"
                        placeholder={question?.field_placeholder ?? ""}
                        className="w-full"
                        step={decimal ? `0.${'0'.repeat(decimal - 1)}1` : '1'}
                        value={value}
                        onChange={e => {
                            const value = e.target.value;
                            if (value === '') {
                                setValue(undefined);
                            } else {
                                const strippedValue = value.replace(/,/g, '');
                                if (!strippedValue.endsWith(".")) {
                                    try {
                                        schema.parse(Number(strippedValue));
                                        errorRef.current = undefined;
                                        setSubmitDisabled && setSubmitDisabled(false);
                                    } catch (error) {
                                        errorRef.current = error as ZodError;
                                        setSubmitDisabled && setSubmitDisabled(true);
                                    }
                                }
                                setValue(strippedValue);
                            }
                        }}
                        min={min ?? undefined}
                        max={max ?? undefined}
                    />
                </div>
            ) : (
                <>
                    {response?.field_value === null || response?.field_value === undefined ? (
                        <p className="text-gray-500">Null or Undefined</p>
                    ) : (
                        <div className="flex">
                            <div className="flex items-center px-2 bg-gray-100 border rounded me-1">$</div>
                            <Input type="number" value={response!.field_value!} className="w-full" disabled />
                        </div>
                    )}
                </>
            )}

            {!disabled && (
                <div className="flex flex-col">
                    {integer !== undefined && integer !== null && <p className="[font-size:12px]">Up to {integer} integer digits</p>}
                    {decimal !== undefined && decimal !== null && <p className="[font-size:12px]">Up to {decimal} decimal digits</p>}
                </div>
            )}

            <div className="flex flex-col gap-2">
                {errorRef.current?.errors?.map((error, index) => (
                    <p key={index} className="text-sm text-red-500">{error.message}</p>
                ))}
            </div>
        </div>
    )
}